import {
  CentraCheckoutApiMappers,
  defaultCentraCheckoutApiMappers,
} from "@made-people/grease-centra";

export const mmCartTotals: CentraCheckoutApiMappers["centraSelectionToGreaseCartTotals"] =
  (totals, items, currencyFormat) => {
    const base =
      defaultCentraCheckoutApiMappers.centraSelectionToGreaseCartTotals(
        totals,
        items,
        currencyFormat,
      );

    return {
      ...base,
      subtotal: {
        number: totals.itemsTotalPriceAsNumber,
        formatted: totals.itemsTotalPrice,
      },
    };
  };
